<script setup lang="ts">
import { SUPPORTED_MIME_TYPES } from '@/backend/types'
import FileUploadMenu from '@/modules/Project/FileUploadMenu.vue'
import type { GoogleDriveFile } from '@/modules/Workspaces/KnowledgeHub/Integrations/GoogleDrive/useGoogleDriveConnection'
import DarwinButton from '@/uiKit/DarwinButton.vue'

const emit = defineEmits<{
  'import:computer': [File[]]
  'import:google': [GoogleDriveFile[]]
}>()
</script>

<template>
  <FileUploadMenu
    v-slot="{ getTriggerProps }"
    library-picker-confirm-label="Add to Hub"
    no-library
    directory
    :supported-mime-types="SUPPORTED_MIME_TYPES"
    @import:computer="emit('import:computer', $event)"
    @import:google="emit('import:google', $event)"
  >
    <DarwinButton
      v-bind="getTriggerProps()"
      variant="black"
      rounded
      size="sm"
    >
      Add data
    </DarwinButton>
  </FileUploadMenu>
</template>
